import { render, staticRenderFns } from "./InternshipPostings.vue?vue&type=template&id=4653de07"
import script from "./InternshipPostings.vue?vue&type=script&lang=js"
export * from "./InternshipPostings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports